import * as React from "react"
import { Col, Container, Hidden, Row, Visible } from "react-grid-system"
import { HorizontalSpacer, Spacer } from "../../atoms/spacers"
import H4 from "../../atoms/typography/H4"
import { theme } from "../../theme"
import styled from "styled-components"
import H1 from "../../atoms/typography/H1"
import PrimaryButton from "../../atoms/buttons/PrimaryButton"
import H3 from "../../atoms/typography/H3"
import { ActiveItemBar } from "../../atoms/ActiveItemColoredBar"
import H2 from "../../atoms/typography/H2"
import Body from "../../atoms/typography/Body"
import BodyLarge from "../../atoms/typography/BodyLarge"
//@ts-ignore
import IafLogo from "../../atoms/icons/images/iaflogo.svg"
//@ts-ignore
import GrcLogo from "../../atoms/icons/images/grclogo.svg"
//@ts-ignore
import IntelsatLogoIcon from "../../atoms/icons/images/intelsatlogoicon.svg"
import { ContactPhoneIcon } from "../../atoms/icons/ContactPhoneIcon"
import { ArrowRight } from "../../atoms/icons/ArrowRight"
import { Link } from "react-router-dom"
import NavigationTextButton from "../../atoms/buttons/NavigationTextButton"
import { MediaQuery } from "../../../utils/design-helpers"
import SmallColorfulButton from "../../atoms/buttons/SmallColorfulButton"
import LoadingSpinner from "../../atoms/LoadingSpinner"
import Markdown from "react-markdown"
import { DownloadProductSheetButton } from "../../molecules/store/DownloadProductSheet"
import { RequestDemoButton } from "../../molecules/store/RequestDemo"
import UspCarousel from "../../molecules/store/ProductPages/UspCarousel"
import { useInView, useScrollToRef } from "../../../utils/helpers"
import { captureExceptionWithContext } from "../../../utils/sentry"
import { secureUspData } from "../../molecules/store/ProductPages/uspData/secure"
import { useProductPageCollection } from "../../../hooks/products/useProductPageCollection"
import { useUspCarousel } from "../../../hooks/products/useUspCarousel"
import { TerminalColorPicker } from "../../molecules/store/ProductPages/TerminalColorPicker"
import UspCarouselTwo from "../../contentful/UspCarouselTwo"

const ProductImage = styled.img`
  width: 100%;
  object-fit: contain;
`
const ColoredTitle = styled(H1)`
  background: ${(props) => props.theme.gradients.green};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
`

const GreySection = styled.div`
  width: 100%;
  background: var(--Darker-grey-gradient, linear-gradient(180deg, #585858 0%, #444 100%));
  position: relative;
  z-index: 2;
`

const HeroGradientBackground = styled.div`
  background: linear-gradient(180deg, #4f533e 0%, #fafafa 100%);
`

const FlexRowColSmall = styled(Col)`
  display: flex;
  flex-direction: column;
  padding: 16px;
  justify-content: space-between;
  height: 322px;

  ${MediaQuery.XS} {
    height: 280px;
  }
`

const FooterImage = styled.img`
  width: 100%;
  height: 259px;
  object-fit: cover;
`

const FooterContainer = styled.div`
  position: absolute;
  top: 25%;
  left: 0;
  padding: 1rem;
  width: 100%;
`

const ContactSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;

  :hover {
    filter: opacity(0.6);
  }
`

const FixedBottomMenu = styled.div`
  width: 100%;
  padding: 0.5rem;
  background-color: rgba(38, 38, 38, 0.6);
  backdrop-filter: blur(3px);
  position: sticky;
  left: 0;
  top: 75px;
  z-index: 4;
  box-shadow: 0px 1px 6px 0px rgba(119, 119, 119, 0.25);

  ${MediaQuery.XS} {
    top: 55px;
  }

  ${MediaQuery.SM} {
    top: 50px;
  }

  ${MediaQuery.MD} {
    top: 50px;
  }

  ${MediaQuery.LG} {
    top: 60px;
  }
`

const MenuNavigationContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex: 0.5;
  align-items: center;
`

const SecureHeroContent = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  padding: 2.75rem 1rem 2.75rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  min-height: 85vh;

  ${MediaQuery.XS} {
    padding: 8px;
    max-width: 90%;
  }
`

const ScaledPartners = styled.div`
  ${MediaQuery.XS} {
    transform: scale(0.5);
  }
`

const PartnersContentOnTop = styled.div`
  width: 100%;

  ${MediaQuery.XS} {
    padding: 1rem;
  }
`

const PartnersSectionContainer = styled.div`
  position: relative;
`

const PartnersSectionSvgStyle = styled.svg`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  min-width: 1432px; // width of the svg box
`

const PartnerSectionBackground = () => (
  <PartnersSectionSvgStyle xmlns="http://www.w3.org/2000/svg" width="1280" fill="none" viewBox="0 0 1280 509">
    <path
      fill="url(#paint0_linear_8394_15317)"
      fillOpacity="0.6"
      d="M-30 0h1414l18 474.5S1213 519 1041.5 506c-160.287-12.15-262.945-90.1-423-105-139.974-13.031-221.235-6.905-359.5 18.5C143.131 440.79-30 506-30 506z"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_8394_15317"
        x1="50.978"
        x2="1151.32"
        y1="92"
        y2="473.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#80B67D"></stop>
        <stop offset="1" stopColor="#AED37C"></stop>
      </linearGradient>
    </defs>
  </PartnersSectionSvgStyle>
)

const NAVBAR_OFFSET = 140

interface UspPointItemProps {
  active: boolean
  title: string
  text: string
}

const UspPointItem: React.FC<UspPointItemProps> = ({ active, title, text }) => {
  return (
    <Row style={{ padding: 8 }}>
      <Col lg={4}>
        {active ? (
          <H2 color={active ? theme.colors.white : theme.colors.greyDisabled}>{title}</H2>
        ) : (
          <H3 color={active ? theme.colors.white : theme.colors.greyDisabled}>{title}</H3>
        )}

        <HorizontalSpacer spacing={0.5} />
        <ActiveItemBar short color={active ? theme.gradients.green : theme.colors.greyDisabled} />
      </Col>
      <Col lg={8}>
        {active ? (
          <BodyLarge color={active ? theme.colors.white : theme.colors.greyDisabled}>{text}</BodyLarge>
        ) : (
          <Body color={active ? theme.colors.white : theme.colors.greyDisabled}>{text}</Body>
        )}
      </Col>
    </Row>
  )
}

const SecureProductPage: React.FC = () => {
  const { productPages, error, loading } = useProductPageCollection()
  const secureProductPage = productPages?.items?.find((x: any) => x.title === "secure")
  const uspCarousel = useUspCarousel("1K6tnj4QogG1pyvDtZqkrc")

  if (error) {
    captureExceptionWithContext(error, "error fetching product pages")
  }

  const overviewRef = React.useRef<HTMLDivElement>(null)
  const applicationsRef = React.useRef<HTMLDivElement>(null)
  const specRef = React.useRef<HTMLDivElement>(null)
  const [activeSection, setActiveSection] = React.useState(0)

  const overviewRefIsInView = useInView(overviewRef)
  const applicationsRefIsInView = useInView(applicationsRef)
  const specRefIsInView = useInView(specRef)

  const scrollToRef = useScrollToRef(NAVBAR_OFFSET)

  React.useEffect(() => {
    if (overviewRefIsInView && !applicationsRefIsInView && !specRefIsInView) {
      setActiveSection(0)
    } else if (!overviewRefIsInView && applicationsRefIsInView && !specRefIsInView) {
      setActiveSection(1)
    } else if (!overviewRefIsInView && !applicationsRefIsInView && specRefIsInView) {
      setActiveSection(2)
    }
  }, [overviewRefIsInView, applicationsRefIsInView, specRefIsInView])

  const scrollToOverview = () => {
    scrollToRef(overviewRef)
  }
  const scrollToApplications = () => {
    scrollToRef(applicationsRef)
  }
  const scrollToSpecs = () => {
    scrollToRef(specRef)
  }

  const [activeSetupStep, setActiveSetupStep] = React.useState(0)

  React.useEffect(() => {
    document.title = "Secure Product"

    // Set up interval for changing activeSetupStep
    const intervalId = setInterval(() => {
      setActiveSetupStep((prevStep) => (prevStep + 1) % 4)
    }, 3000)

    // Clean up on component unmount
    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return (
    <div style={{ position: "relative" }}>
      <FixedBottomMenu>
        <Container>
          <Row nogutter justify="between" align="center">
            <Hidden xs>
              <H2 color={theme.colors.white}>Satcube Secure</H2>
            </Hidden>
            <Visible xs>
              <H3 color={theme.colors.white}>
                Satcube<H3 color={theme.colors.white}>Secure</H3>
              </H3>
            </Visible>
            <Hidden xs sm md>
              <MenuNavigationContainer>
                <NavigationTextButton
                  title="Overview"
                  onClick={scrollToOverview}
                  active={activeSection === 0}
                  color={theme.colors.white}
                  subMenu
                />
                <Spacer spacing={1} />
                <NavigationTextButton
                  title="Applications"
                  onClick={scrollToApplications}
                  active={activeSection === 1}
                  color={theme.colors.white}
                  subMenu
                />
                <Spacer spacing={1} />
                <NavigationTextButton
                  title="Specifications"
                  onClick={scrollToSpecs}
                  active={activeSection === 2}
                  color={theme.colors.white}
                  subMenu
                />
              </MenuNavigationContainer>
            </Hidden>
            <Link to="/store/customize/secure">
              <SmallColorfulButton
                title="Customise and order"
                variant="green"
                iconRight={<ArrowRight color="white" />}
              />
            </Link>
          </Row>
        </Container>
      </FixedBottomMenu>
      <HeroGradientBackground>
        <HorizontalSpacer spacing={2} />
        <div ref={overviewRef} id="overviewSection">
          <Container>
            <Row align="center">
              <Col lg={6}>
                <ProductImage src="https://images.ctfassets.net/kzqg847wz5jr/73FcJg922vFymFZ5xx6rMf/3d2100a6ec6c5f9f352b83c4239b9d06/Secure_header.webp" />
              </Col>
              <Col lg={6} style={{ padding: 16 }}>
                {loading && <LoadingSpinner />}
                <H4 color={theme.colors.white} textAlign="center">
                  {secureProductPage?.promoTitleOne}
                </H4>
                <HorizontalSpacer spacing={1} />
                <H1 textAlign="center" color={theme.colors.white}>
                  {secureProductPage?.promoTitleGradient}
                </H1>
                <HorizontalSpacer spacing={1} />
                <H4 color={theme.colors.white} textAlign="center">
                  {secureProductPage?.promoSubtitle}
                </H4>
                <HorizontalSpacer spacing={1} />
                <Row align="center" justify="center" nogutter>
                  <DownloadProductSheetButton productSheetType="satcube_secure" buttonType="colorgreen" />
                  <Hidden xs md>
                    <Visible lg>
                      <Spacer spacing={0.25} />
                    </Visible>
                    <Visible xl xxl xxxl>
                      <Spacer spacing={2.25} />
                    </Visible>
                    <RequestDemoButton productType="satcube_secure" buttonType="primary" />
                  </Hidden>
                </Row>
                <Visible xs md>
                  <HorizontalSpacer spacing={2} />
                  <Row justify="center">
                    <RequestDemoButton productType="satcube_secure" buttonType="primary" />
                  </Row>
                </Visible>
              </Col>
            </Row>
          </Container>
        </div>

        <HorizontalSpacer spacing={6} />

        <Container>
          <Visible xs sm md>
            <H1 bold textAlign="center">
              New Satcube Ku
            </H1>
            <HorizontalSpacer spacing={1} />
          </Visible>
          <Row justify="center">
            <Visible xs sm md>
              <Col>
                <Row justify="center">
                  <TerminalColorPicker product="ku" />
                </Row>
              </Col>
            </Visible>
            <Col lg={6}>
              <Row justify="center">
                <Col>
                  <Hidden xs sm md>
                    <H1 bold>Satcube Secure for Governments</H1>
                  </Hidden>
                  <HorizontalSpacer spacing={1} />
                  <H3>Upgraded terminal with improved robustness and stealth for mission-critical communications</H3>
                  <HorizontalSpacer spacing={1.5} />
                  <ul>
                    <li>
                      <Body>Ultra portable & secure Wi-Fi hotspot with speeds up to 20 mbps up & down</Body>
                    </li>
                    <li>
                      <Body>
                        iDirect 950mp modem, supporting one-way and two-way TRANSEC, & FIPS140-2 Level 3 certified
                      </Body>
                    </li>
                    <li>
                      <Body>GNSS-independent - functional in GPS-denied environments</Body>
                    </li>
                    <li>
                      <Body>Upgraded security features - Dark mode and PIN lock</Body>
                    </li>
                    <li>
                      <Body>Instant connectivity - going from case to Wi-Fi in just a minute</Body>
                    </li>
                    <li>
                      <Body>Easily transported in backpack with its weight of only 9.5kgs</Body>
                    </li>
                    <li>
                      <Body>
                        Battery-driven and IP 65 certified(IP 67 optional), tested for temperatures from -35° to +60° C
                      </Body>
                    </li>
                    <li>
                      <Body>Outperforms traditional devices in size, speed, ease-of-use and design</Body>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
            <Hidden xs sm md>
              <Col lg={4}>
                <Row justify="end">
                  <TerminalColorPicker product="ku" />
                </Row>
              </Col>
            </Hidden>
          </Row>
        </Container>
        <HorizontalSpacer spacing={6} />
      </HeroGradientBackground>

      <GreySection>
        <Container>
          <HorizontalSpacer spacing={8} />
          {uspCarousel.data && <UspCarouselTwo uspCarousel={uspCarousel.data} />}
          {/* <UspCarousel color={theme.gradients.blue} data={kuUspData} /> */}
          <HorizontalSpacer spacing={8} />
        </Container>
      </GreySection>

      <div style={{ position: "relative" }}>
        <video
          src="https://videos.ctfassets.net/kzqg847wz5jr/2DiDgVKLQfs6QjifVohjC/9a2c14d94350666ff1d89fd074293147/12347b40-2d04-43d1-9db6-f4d3079f342c.webm"
          poster="https://images.ctfassets.net/kzqg847wz5jr/54Ntk5lpuQ6qO6UPRWtVJs/01118e74cb4658eb22a5979df7d7c3d8/Rentals_header.webp"
          style={{
            width: "100%",
            height: "75vh",
            objectFit: "cover",
            marginBottom: -8,
          }}
          loop
          autoPlay
          muted
          playsInline
        />
        <SecureHeroContent>
          <Container>
            <Col lg={9}>
              <ColoredTitle>{secureProductPage?.internetCoverageTitle}</ColoredTitle>
            </Col>
            <HorizontalSpacer spacing={2} />
            <Col lg={6}>
              <Hidden xs md>
                <Row justify="between" nogutter>
                  <H3 color="white">Infrastructure</H3>
                  <H3 color="white">Law and justice</H3>
                  <H3 color="white">Security</H3>
                  <H3 color="white">Communication</H3>
                </Row>
              </Hidden>
              <Visible xs md>
                <Row nogutter justify="between">
                  <H3 color="white">Infrastructure</H3>
                  <H3 color="white">Law and justice</H3>
                </Row>
                <HorizontalSpacer spacing={1} />
                <Row nogutter justify="between">
                  <H3 color="white">Security</H3>
                  <H3 color="white">Communication</H3>
                </Row>
              </Visible>
              <HorizontalSpacer spacing={2} />
              <Body color="white">
                <Markdown>{secureProductPage?.internetCoverageText}</Markdown>
              </Body>
            </Col>
            <HorizontalSpacer spacing={2} />
            <Link to="/applications">
              <SmallColorfulButton
                variant="green"
                title="Read more about applications"
                iconRight={<ArrowRight color="white" />}
              />
            </Link>
          </Container>
          <HorizontalSpacer spacing={2} />
        </SecureHeroContent>
      </div>

      <GreySection>
        <HorizontalSpacer spacing={6} />
        <Container>
          <UspPointItem
            active={activeSetupStep === 0}
            title={secureProductPage?.uspOneTitle}
            text={secureProductPage?.uspOneText}
          />
          <HorizontalSpacer spacing={2} />
          <UspPointItem
            active={activeSetupStep === 1}
            title={secureProductPage?.uspTwoTitle}
            text={secureProductPage?.uspTwoText}
          />
          <HorizontalSpacer spacing={2} />
          <UspPointItem
            active={activeSetupStep === 2}
            title={secureProductPage?.uspThreeTitle}
            text={secureProductPage?.uspThreeText}
          />
          <HorizontalSpacer spacing={2} />
          <UspPointItem
            active={activeSetupStep === 3}
            title={secureProductPage?.uspFourTitle}
            text={secureProductPage?.uspFourText}
          />
        </Container>
        <HorizontalSpacer spacing={6} />

        <Row>
          <Col lg={6}>
            <Row justify="center" align="center" style={{ height: "100%" }}>
              <Col xs={8}>
                <H1 color="white">{secureProductPage?.applicationsTitle}</H1>
                <HorizontalSpacer spacing={1} />
                <Body color="white">
                  <Markdown>{secureProductPage?.applicationsText}</Markdown>
                </Body>
              </Col>
            </Row>
          </Col>
          <Col lg={6}>
            <img
              src="https://images.ctfassets.net/kzqg847wz5jr/4RfwN0S6LYefQ7cvZzv3ON/e89fa9f2e86a1a729eb010151dc210f2/people.png"
              alt="Secured connectivity"
              style={{ width: "100%", height: "100%", maxHeight: "75vh", objectFit: "cover" }}
            />
          </Col>
        </Row>

        <div style={{ position: "relative" }}>
          <PartnersSectionContainer>
            <HorizontalSpacer spacing={4} />
            <Hidden xs sm md>
              <PartnerSectionBackground />
            </Hidden>
          </PartnersSectionContainer>

          <PartnersContentOnTop>
            <Container>
              <H3 textAlign="center" color={theme.colors.white}>
                Some of our customers:
              </H3>
              <Hidden xs md>
                <Row justify="around" align="center">
                  <IafLogo />
                  <GrcLogo />
                  <img
                    src="https://images.ctfassets.net/kzqg847wz5jr/5CRhTYFTNolM0CqlPoIp9m/903bb5984720332dcbadcf86fd4ef675/US_DoD.webp"
                    width={256}
                    style={{ objectFit: "contain" }}
                  />
                </Row>
              </Hidden>
              <Visible xs md>
                <Row justify="center" align="center">
                  <Col xs={6} md={6}>
                    <ScaledPartners>
                      <IafLogo />
                    </ScaledPartners>
                  </Col>
                  <Col xs={6} md={6}>
                    <ScaledPartners>
                      <GrcLogo />
                    </ScaledPartners>
                  </Col>
                  <Col xs={6} md={6}>
                    <img
                      src="https://images.ctfassets.net/kzqg847wz5jr/5CRhTYFTNolM0CqlPoIp9m/903bb5984720332dcbadcf86fd4ef675/US_DoD.webp"
                      style={{ objectFit: "contain", width: "100%" }}
                    />
                  </Col>
                </Row>
              </Visible>
              <HorizontalSpacer spacing={1} />
              <Row justify="center">
                <div style={{ maxWidth: 680 }}>
                  <Body color={theme.colors.white} textAlign="center">
                    <Markdown>{secureProductPage?.quote}</Markdown>
                  </Body>
                </div>
              </Row>
            </Container>
          </PartnersContentOnTop>
        </div>

        <Container>
          <HorizontalSpacer spacing={15} />

          <div ref={specRef} id="specsSection" />
          <Row align="center">
            <Col lg={1} />
            <Col lg={5}>
              <img src="https://images.ctfassets.net/kzqg847wz5jr/4WziXC4UkB9kgUoPzrsnnk/de9601ec9484868a2f9cce595563cfae/Satcube_Secure-exploded2transprent_1.png" />
            </Col>
            <Col lg={5}>
              <ColoredTitle>Handmade hightech</ColoredTitle>
              <H2 color="white">Technical specifications</H2>
            </Col>
          </Row>
          <HorizontalSpacer spacing={4} />
          <Row>
            <FlexRowColSmall lg={4}>
              <div>
                <H3 color="white">Dimensions</H3>
                <HorizontalSpacer spacing={0.5} />
                <Body color="white">9.5 kg; 470 x 320 x 75 mm</Body>
                <HorizontalSpacer spacing={0.25} />
                <Body color="white">21 lbs; 18.5 x 12.6 x 2.95 inch</Body>
              </div>
              <div>
                <H3 color="white">Environmental rating</H3>
                <HorizontalSpacer spacing={0.5} />
                <Body color="white">IP65/IP67 water and dust proof </Body>
              </div>
              <div>
                <H3 color="white">Power</H3>
                <HorizontalSpacer spacing={0.5} />
                <Body color="white">24 VDC, 130 W</Body>
                <HorizontalSpacer spacing={0.25} />
                <Body color="white">AC/DC 100 - 240 VAC, </Body>
                <HorizontalSpacer spacing={0.25} />
                <Body color="white">47 - 63 Hz</Body>
              </div>
            </FlexRowColSmall>
            <FlexRowColSmall lg={4}>
              <div>
                <H3 color="white">Antenna parameters</H3>
                <HorizontalSpacer spacing={0.5} />
                <Body color="white">Tx: 13.75 - 14.50 GHz (Ku band)</Body>
                <HorizontalSpacer spacing={0.25} />
                <Body color="white">Rx: 10.95 - 12.75 GHz (Ku band)</Body>
                <HorizontalSpacer spacing={0.25} />
                <Body color="white">Linear polarisation</Body>
                <HorizontalSpacer spacing={0.25} />
                <Body color="white">EIRP: 46 dBW</Body>
                <HorizontalSpacer spacing={0.25} />
                <Body color="white">G/T: 9 db/K</Body>
              </div>
              <div>
                <H3 color="white">Internal modem</H3>
                <HorizontalSpacer spacing={0.5} />
                <Body color="white">iDirect 950mp</Body>
              </div>
              <div>
                <H3 color="white">Approvals</H3>
                <HorizontalSpacer spacing={0.5} />
                <Body color="white">CE [RED directive (2014/</Body>
                <HorizontalSpacer spacing={0.25} />
                <Body color="white">53/UE), EN 301 428)] FCC</Body>
              </div>
            </FlexRowColSmall>
            <FlexRowColSmall lg={4}>
              <div>
                <H3 color="white">Wide temperature range</H3>
                <HorizontalSpacer spacing={0.5} />
                <Body color="white">-35°C to 60°C / -31°F to 140°F</Body>
              </div>
              <div>
                <H3 color="white">Data rate</H3>
                <HorizontalSpacer spacing={0.5} />
                <Body color="white">Up to 85/20Mbps via HTS</Body>
              </div>
              <div>
                <H3 color="white">Security</H3>
                <HorizontalSpacer spacing={0.5} />
                <Body color="white">FIPS 140-2 Level 3 Certified</Body>
                <HorizontalSpacer spacing={0.25} />
                <Body color="white">(#3056) TRANSEC module</Body>
                <HorizontalSpacer spacing={0.25} />
                <Body color="white">(E0002268) AES Link</Body>
                <HorizontalSpacer spacing={0.25} />
                <Body color="white">Encryption (256-bit)**</Body>
                <HorizontalSpacer spacing={0.25} />
                <Body color="white">X.509 Digital Certificates</Body>
                <HorizontalSpacer spacing={0.25} />
                <Body color="white">Automatic Key Management</Body>
              </div>
            </FlexRowColSmall>
          </Row>
          <HorizontalSpacer spacing={6.5} />
          <Row nogutter justify="center" align="center">
            <DownloadProductSheetButton productSheetType="satcube_secure" buttonType="colorgreen" />
            <Hidden xs md>
              <Spacer spacing={3} />

              <Link to="/store#secure">
                <PrimaryButton title="Discover Satcube products" iconRight={<ArrowRight />} />
              </Link>
            </Hidden>
          </Row>
          <Visible xs md>
            <HorizontalSpacer spacing={2} />
            <Row justify="center">
              <Link to="/store#secure">
                <PrimaryButton title="Discover more" iconRight={<ArrowRight />} />
              </Link>
            </Row>
          </Visible>

          <HorizontalSpacer spacing={8} />
        </Container>
      </GreySection>

      <div style={{ position: "relative", width: "100%" }}>
        <FooterImage src="https://images.ctfassets.net/kzqg847wz5jr/6rKCb30C8dmUH7B3BGroA0/cd1aa7009791709c369a97b9d6685170/MicrosoftTeams-image__2_.png" />
        <FooterContainer>
          <Container>
            <Row justify="between">
              <div>
                <H1 color="white">Want to know more?</H1>
                <RequestDemoButton productType="satcube_secure" buttonType="textwhite" />
                <Visible xs>
                  <HorizontalSpacer spacing={2} />
                </Visible>
              </div>
              <Link to="/contact">
                <ContactSection>
                  <ContactPhoneIcon color="white" />
                  <Spacer spacing={1} />
                  <H3 color="white">Contact sales</H3>
                </ContactSection>
              </Link>
            </Row>
          </Container>
        </FooterContainer>
      </div>
    </div>
  )
}

export default SecureProductPage
